import { buildStoneRequest, type StoneRequestMode } from "@gull/shared";
import type { DraftItem, ShippingAddressDraft } from "./types";

export interface MailOrderPayloadInput {
  address: ShippingAddressDraft;
  stoneMode: StoneRequestMode;
  selectedStoneItemIndexes: number[];
  items: DraftItem[];
  orderImagePaths: string[];
  bankAccountNumber: string;
  kontoEier: string;
  salesTermsAccepted: boolean;
}

export function buildMailOrderPayload(input: MailOrderPayloadInput) {
  return {
    shippingAddress: {
      line1: input.address.line1.trim(),
      line2: input.address.line2.trim() || null,
      postalCode: input.address.postalCode.trim(),
      city: input.address.city.trim(),
      country: input.address.country.trim() || "NO",
    },
    ...buildStoneRequest(input.stoneMode, input.selectedStoneItemIndexes),
    items: input.items.map((item) => ({
      description: item.description.trim(),
    })),
    orderImageUrls: input.orderImagePaths,
    bankAccountNumber: input.bankAccountNumber.trim() || undefined,
    kontoEier: input.kontoEier.trim() || undefined,
    salesTermsAccepted: input.salesTermsAccepted,
  };
}

export type MailOrderPayload = ReturnType<typeof buildMailOrderPayload>;
